// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileStoreSaleStat_borderBottom__CDEFh","moveIcon":"AdminMobileStoreSaleStat_moveIcon__ZAXv1","listMoveClick":"AdminMobileStoreSaleStat_listMoveClick__8YGkT"};